/**
 * Monta o objeto de assinatura para concessão manual pelo painel admin.
 * Lógica pura (sem Firestore) para ser testável. O chamador adiciona
 * `updatedAt`/`updatedBy` e persiste com merge.
 *
 * Expiração no app depende de `currentPeriodEnd`: se ausente ou no futuro,
 * a assinatura é considerada válida. Vitalício grava uma data bem distante
 * mais a flag `lifetime` para exibição.
 */

/** Data usada para assinatura vitalícia (efetivamente "nunca expira"). */
export const LIFETIME_END = new Date('2099-12-31T23:59:59.000Z');

function addMonths(from, months) {
  const d = new Date(from.getTime());
  d.setMonth(d.getMonth() + months);
  return d;
}

export function buildManualSubscription({
  plan,
  status,
  durationInMonths = 1,
  lifetime = false,
  now = new Date(),
} = {}) {
  const base = { plan, status, provider: 'internal' };

  if (plan === 'free') {
    return { ...base, lifetime: false };
  }

  if (lifetime) {
    return {
      ...base,
      status: 'active',
      lifetime: true,
      startDate: now,
      currentPeriodEnd: LIFETIME_END,
      endDate: LIFETIME_END,
    };
  }

  if (status === 'active') {
    const months = Math.max(1, parseInt(String(durationInMonths), 10) || 1);
    const end = addMonths(now, months);
    return {
      ...base,
      lifetime: false,
      startDate: now,
      currentPeriodEnd: end,
      endDate: end,
    };
  }

  // Plano pago mas inativo/cancelado: sem datas de vigência.
  return { ...base, lifetime: false };
}
